
        <div id="logout" (click)="showPopup()" class=" transparent pull-right">
        <span > <a routerlink="/auth/login" title="Sign Out" data-action="userLogout"
                  data-logout-msg="You can improve your security further after logging out by closing this opened browser">
            <i nz-icon nzType="logout" style="color: black" nzTheme="outline"></i></a> </span>
        </div>
    